import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ru from './lang/ru'

Vue.use(VueI18n)

let messages = {
    // en : english,
    ru : ru,
}

export default new VueI18n({
    locale: 'ru',
    //locale: window.localStorage.Language || 'ru',
    fallbackLocale: 'ru',
    messages
})
